export default __webpack_public_path__ + "static/media/p8.11c49a36.jpg";